"use client";

import { useState } from "react";
import { FaChevronLeft, FaSearch } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";
import { ChatDetailScreen } from "../chat-detail";

interface ChatMessagesScreenProps {
  onBack: () => void;
}

export default function ChatMessagesScreen({
  onBack,
}: ChatMessagesScreenProps) {
  const [showChatDetail, setShowChatDetail] = useState(false);

  if (showChatDetail) {
    return <ChatDetailScreen onBack={() => setShowChatDetail(false)} />;
  }
  return (
    <div className="h-full bg-background text-foreground flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3">
        <button onClick={onBack} className="p-2">
          <FaChevronLeft className="text-blue-400 text-xl" />
        </button>
        <div className="flex items-center gap-4">
          <button className="bg-accent text-accent-foreground px-6 py-2 rounded-full text-base font-medium">
            Register
          </button>
          <button className="text-blue-400 text-base">Sign In</button>
        </div>
        <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center">
          <span className="text-foreground text-xs font-medium">MQL5</span>
        </div>
      </div>

      {/* Search Bar */}
      <div className="px-4 pb-4">
        <div className="relative">
          <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search for messages or chats"
            className="w-full bg-background text-foreground placeholder-muted-foreground rounded-lg pl-10 pr-4 py-3 focus:outline-none focus:ring-2 focus:ring-ring"
          />
        </div>
      </div>

      {/* Chat List */}
      <div className="flex-1 overflow-y-auto">
        <button
          onClick={() => setShowChatDetail(true)}
          className="w-full flex items-center px-4 py-4 hover:bg-background/50 transition-colors"
        >
          <div className="w-14 h-14 rounded-full bg-primary flex items-center justify-center mr-3">
            <FiMenu className="text-foreground text-2xl" />
          </div>
          <div className="flex-1 text-left">
            <div className="text-base font-medium">
              FXPRO Financial Services Ltd
            </div>
            <div className="text-sm text-muted-foreground mt-1">Margin Call Alert!</div>
          </div>
          <div className="text-sm text-muted-foreground">12/27/24</div>
        </button>
      </div>

      {/* Bottom Section */}
      <div className="px-4 py-6 text-center">
        <p className="text-blue-400 text-base">My MetaQuotes ID: C3FA832C</p>
      </div>
    </div>
  );
}
